module.exports = __webpack_public_path__ + "american_star_color.png";


//////////////////
// WEBPACK FOOTER
// ./images/american_star_color.png
// module id = 179
// module chunks = 0